import React, { useMemo, useState } from "react";
import Table from "../../../../components/Table";
import TitleButtons from "../../../../components/TitleButtons";
import { generatePdfReport } from "../../../../utils/pdf/generatePdfReport";
import numeroParaExtenso from "../../../../utils/numeroPorExtenso";
import { useEntradasSuprimentos } from "./entradasData"; // usa o hook atualizado

const SuprimentosEstoqueEntradas: React.FC = () => {
  const headers = [
    "Responsável",
    "Código",
    "Nome do Produto",
    "Custo Unitário",
    "Quantidade",
    "Posição",
    "Data",
    "Hora",
  ];

  const columnWidths = [
    "160px", // Responsável — dei mais espaço
    "90px",
    "360px",
    "120px",
    "90px",
    "80px",
    "100px",
    "80px",
  ];

  const { rows, loading, refresh } = useEntradasSuprimentos();

  const [selectedColumns, setSelectedColumns] = useState<boolean[]>(
    headers.map(() => true)
  );

  const enabledColumnIndexes = useMemo(
    () =>
      selectedColumns
        .map((checked, i) => (checked ? i : -1))
        .filter((i) => i !== -1),
    [selectedColumns]
  );

  // Agora quantidade está na COLUNA 4 (índice 4)
  const totalProdutos = useMemo(
    () =>
      rows.reduce((acc, r) => {
        const qtd = parseInt(r[4] as string, 10);
        return acc + (Number.isFinite(qtd) ? qtd : 0);
      }, 0),
    [rows]
  );

  // Agora custo está na COLUNA 3 (índice 3) e quantidade na 4 (índice 4)
  const valorTotal = useMemo(() => {
    return rows.reduce((acc, r) => {
      const custo = parseFloat(
        String(r[3])
          .replace(/[^\d,]/g, "")
          .replace(",", ".")
      );
      const qtd = parseInt(r[4] as string, 10);
      const inc =
        Number.isFinite(custo) && Number.isFinite(qtd) ? custo * qtd : 0;
      return acc + inc;
    }, 0);
  }, [rows]);

  return (
    <div>
      <TitleButtons
        title="Suprimentos - Entradas no Estoque"
        buttons={[
          {
            label: loading ? "Carregando..." : "Gerar Relatório",
            onClick: () =>
              generatePdfReport({
                reportTitle: "Relatório de Entradas Estoque - Suprimentos",
                fileNamePrefix: "Suprimentos-Estoque-Entradas",
                subtitle: "Informações dos Produtos Adicionados no Estoque",
                headers,
                rows,
                custoColIndex: 3, // <- "Custo Unitário" agora é a 4ª coluna
                enabledColumns: enabledColumnIndexes,
                footerLines: [
                  `Total de Produtos Adicionados no Estoque: ${totalProdutos}`,
                  `Valor Total de Produtos Adicionados no Estoque: R$ ${valorTotal.toLocaleString(
                    "pt-BR",
                    { minimumFractionDigits: 2 }
                  )} (${numeroParaExtenso(Math.floor(valorTotal))} reais)`,
                ],
              }),
            variant: "secondary",
            dropdownOptions: headers.map((h, i) => ({
              label: h,
              checked: selectedColumns[i],
            })),
            onOptionChange: (index, checked) => {
              setSelectedColumns((prev) => {
                const updated = [...prev];
                updated[index] = checked;
                return updated;
              });
            },
          },
        ]}
      />

      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        responsiveWidths={{
          1300: {
            1: "140px",
            2: "80px",
            3: "320px",
            4: "110px",
            5: "80px",
            6: "70px",
            7: "100px",
            8: "70px",
          },
        }}
      />
    </div>
  );
};

export default SuprimentosEstoqueEntradas;
